import {
  type MutationFunction,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { inflect } from 'inflection';

import c from '../utils/constants';

interface UseCreateMultipleAttachmentsProps {
  disableHide?: boolean;
  referenceId?: string;
}

type PAYLOAD = {
  source: string;
  referenceId: string;
  fileUrl: string;
  fileType: string;
  fileName: string;
  fileThumbnail?: string;
  fileSize: number;
};

export default function useCreateMultipleAttachments({
  disableHide = false,
  referenceId,
}: UseCreateMultipleAttachmentsProps = {}) {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  const mutationFn: MutationFunction<any, PAYLOAD[]> = async (payload) => {
    const api = new Api(args);

    const data = await api.post(
      await withAcl({
        account: {
          url: 'api/v1/attachments/multiple',
          payload,
        },
        admin: {
          url: `api/v2/accounts/${accountId}/users/${accountUserId}/attachments/multiple`,
          payload,
        },
      }),
    );

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: (_data, payload) => {
      queryClient.invalidateQueries({ queryKey: [c.ATTACHMENTS, {}] });
      queryClient.invalidateQueries({ queryKey: [c.LOGS, referenceId] });

      if (!disableHide) hideModal();

      toastSuccess(
        `Successfully created ${inflect('attachment', payload.length)}`,
      );
    },
  });
}
